export default "__VITE_PUBLIC_ASSET__de4ef61e__"